/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './findRelatedAccounts.defs.js'
export { main as default } from './findRelatedAccounts.defs.js'
